import * as React from 'react';

import type Maybe from 'graphql/tsutils/Maybe';
import moment from 'moment';

import GrowthEpicClient from 'bundles/epic/clients/Growth';
import { useIntl } from 'bundles/page/lib/useIntl';
import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';
import PAGE_TYPES from 'bundles/unified-description-page-common/constants/pageTypes';

import _t from 'i18n!nls/xdp';

type Props = {
  estimatedWorkload?: Maybe<string>;
  totalHoursOverride?: Maybe<string>;
  pageType?: (typeof PAGE_TYPES)[keyof typeof PAGE_TYPES];
};

function formatLabel(intl: ReturnType<typeof useIntl>, totalHours: number, showApprox: boolean) {
  const label = showApprox
    ? _t('{totalHours} {totalHours, plural, =1 {hour} other {hours}} (approximately)')
    : _t('{totalHours} {totalHours, plural, =1 {hour} other {hours}}');
  return intl.formatMessage(label, {
    totalHours: Math.max(Math.round(totalHours), 1),
  });
}

export const KeyInformationProjectDuration = ({ estimatedWorkload, totalHoursOverride, pageType }: Props) => {
  const intl = useIntl();
  let title = '';
  const isPortfolioProject = pageType === PAGE_TYPES.PORTFOLIO_PROJECT;

  const variant = GrowthEpicClient.preview('learningHoursVariant');
  if (variant && variant !== 'CONTROL' && totalHoursOverride) {
    const totalHours = moment.duration(totalHoursOverride).asHours();
    title = formatLabel(intl, totalHours, false);
  } else if (estimatedWorkload) {
    title = estimatedWorkload;
  } else {
    const defaultHours = isPortfolioProject ? 6 : 2;
    title = formatLabel(intl, defaultHours, true);
  }

  return (
    <KeyInformationDetailsItem
      title={title}
      subtitle={isPortfolioProject ? _t('Complete at your own pace') : _t('Learn at your own pace')}
    />
  );
};

export default KeyInformationProjectDuration;
